/**
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('./index.js').H} H
 */
import { sanitizeUri } from 'micromark-util-sanitize-uri';
import { u } from 'unist-builder';
import { all } from './traverse.js';
import { wrap } from './wrap.js';
/**
 * @param {H} h
 */

export function footer(h) {
  var index = -1;
  /** @type {Array<ElementContent>} */

  var listItems = [];

  while (++index < h.footnoteOrder.length) {
    var def = h.footnoteById[h.footnoteOrder[index].toUpperCase()];

    if (!def) {
      continue;
    }

    var content = all(h, def);
    var id = String(def.identifier);
    var safeId = sanitizeUri(id.toLowerCase());
    var referenceIndex = 0;
    /** @type {Array<ElementContent>} */

    var backReferences = [];

    while (++referenceIndex <= h.footnoteCounts[id]) {
      /** @type {Element} */
      var backReference = {
        type: 'element',
        tagName: 'a',
        properties: {
          href: '#' + h.clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : ''),
          dataFootnoteBackref: true,
          className: ['data-footnote-backref'],
          ariaLabel: h.footnoteBackLabel
        },
        children: [{
          type: 'text',
          value: '↩'
        }]
      };

      if (referenceIndex > 1) {
        backReference.children.push({
          type: 'element',
          tagName: 'sup',
          children: [{
            type: 'text',
            value: String(referenceIndex)
          }]
        });
      }

      if (backReferences.length > 0) {
        backReferences.push({
          type: 'text',
          value: ' '
        });
      }

      backReferences.push(backReference);
    }

    var tail = content[content.length - 1];

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      var _tail$children;

      var tailTail = tail.children[tail.children.length - 1];

      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' ';
      } else {
        tail.children.push({
          type: 'text',
          value: ' '
        });
      }

      (_tail$children = tail.children).push.apply(_tail$children, backReferences);
    } else {
      content.push.apply(content, backReferences);
    }
    /** @type {Element} */


    var listItem = {
      type: 'element',
      tagName: 'li',
      properties: {
        id: h.clobberPrefix + 'fn-' + safeId
      },
      children: wrap(content, true)
    };

    if (def.position) {
      listItem.position = def.position;
    }

    listItems.push(listItem);
  }

  if (listItems.length === 0) {
    return null;
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {
      dataFootnotes: true,
      className: ['footnotes']
    },
    children: [{
      type: 'element',
      tagName: 'h2',
      properties: {
        id: 'footnote-label',
        className: ['sr-only']
      },
      children: [u('text', h.footnoteLabel)]
    }, {
      type: 'text',
      value: '\n'
    }, {
      type: 'element',
      tagName: 'ol',
      properties: {},
      children: wrap(listItems, true)
    }, {
      type: 'text',
      value: '\n'
    }]
  };
}